/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import InstantWinSelectComponent from "./instantWinSelect.component";
import InstantWinSelectPanelComponent from "./instantWinSelectPanel.component";
import { addAlert } from "modules/notification";
import { useDispatch, useSelector } from "react-redux";
import { getApiLang, getLang } from "app/feature/constants";
import loyaltyPointApi from "app/api/loyaltyProgram";

function InstantWinSelectContainer({
  handleChange,
  value,
  disabled,
  id,
  productUuids,
}) {
  const dispatch = useDispatch();

  const lang = useSelector((state) => state.constant.languages);

  const [instantWins, setInstantWins] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [filter, setFilter] = useState({
    start: 0,
    length: 25,
    search: "",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const isReloadRef = useRef(false);
  const isLoadingRef = useRef(false);

  useEffect(() => {
    if (instantWins.length <= 0) return;

    isReloadRef.current = true;
    setFilter({
      start: 0,
      length: 25,
      search: "",
    });
  }, [productUuids]);

  useEffect(() => {
    getData();
  }, [filter]);

  const getData = () => {
    if (isLoadingRef.current) return;
    if (productUuids.length <= 0) return;

    setIsLoading(true);
    setIsError(false);
    isLoadingRef.current = true;

    loyaltyPointApi
      .getInstantWinLoyaltyPoint({
        uuid: id,
        start: filter.start * filter.length,
        length: filter.length,
        search: filter.search,
        product_uuids: productUuids,
      })
      .then((res) => {
        let list = [];
        if (isReloadRef.current) {
          isReloadRef.current = false;
          list = res.data.data;
        } else {
          list = [...instantWins, ...res.data.data];
        }
        setInstantWins(list);
        setHasMore(list.length < res.data.recordsFiltered);
      })
      .catch((error) => {
        dispatch(
          addAlert({
            severity: "error",
            message: getApiLang(lang, error.code),
          })
        );
        setIsError(true);
      })
      .finally(() => {
        isLoadingRef.current = false;
        setIsLoading(false);
      });

    setIsLoading(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    isReloadRef.current = true;
    setFilter({
      start: 0,
      length: 25,
      search: "",
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSearch = async (values) => {
    setFilter((prev) => ({ ...prev, search: values }));
  };

  const handleSelect = (v) => {
    const temp = value.slice();
    const index = temp.findIndex((t) => t.uuid === v.uuid);
    if (index === -1) {
      temp.push(v);
    } else {
      temp.splice(index, 1);
    }
    handleChange(temp);
  };

  const handleFetchMoreItems = () => {
    if (isLoading || !hasMore) return;

    setFilter((prev) => ({
      ...prev,
      start: prev.start + 1,
    }));
  };

  const handleReload = () => {
    isReloadRef.current = true;
    setFilter({
      start: 0,
      length: 25,
      search: "",
    });
  };

  return (
    <>
      <InstantWinSelectComponent
        handleClick={handleClick}
        value={value}
        placeholder={getLang(lang, "placeholder.SELECT_INSTANT_WIN")}
        disabled={disabled}
        lang={lang}
      />
      <InstantWinSelectPanelComponent
        value={value}
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
        isLoading={isLoading}
        handleSelect={handleSelect}
        list={instantWins}
        hasMore={hasMore}
        isError={isError}
        handleSearch={handleSearch}
        lang={lang}
        handleFetchMoreItems={handleFetchMoreItems}
        handleReload={handleReload}
      />
    </>
  );
}
export default InstantWinSelectContainer;
